export const PERMISSIONS = {    
    ADMINISTRATION: {
        EDIT: "ADMINISTRATION.EDIT",
        CREATE: "ADMINISTRATION.CREATE",
        DELETE: "ADMINISTRATION.DELETE",
        IMPORT: "ADMINISTRATION.IMPORT",
        EXPORT: "ADMINISTRATION.EXPORT",
        VIEW: "ADMINISTRATION.VIEW",
    },
    CLIENT_MANAGEMENT: {
        EDIT: "CLIENT_MANAGEMENT.EDIT",
        CREATE: "CLIENT_MANAGEMENT.CREATE",
        DELETE: "CLIENT_MANAGEMENT.DELETE",
        IMPORT: "CLIENT_MANAGEMENT.IMPORT",
        EXPORT: "CLIENT_MANAGEMENT.EXPORT",
        VIEW: "CLIENT_MANAGEMENT.VIEW",
    },
    USERS_CLIENT: {
        EDIT: "USERS_CLIENT.EDIT",
        CREATE: "USERS_CLIENT.CREATE",
        DELETE: "USERS_CLIENT.DELETE",
        IMPORT: "USERS_CLIENT.IMPORT",
        EXPORT: "USERS_CLIENT.EXPORT",
        VIEW: "USERS_CLIENT.VIEW",
    },
    ROLES: {
        EDIT: "ROLES.EDIT",
        CREATE: "ROLES.CREATE",
        DELETE: "ROLES.DELETE",
        IMPORT: "ROLES.IMPORT",
        EXPORT: "ROLES.EXPORT",
        VIEW: "ROLES.VIEW",
    },
    ORGANIZATIONAL_STRUCTURE: {
        EDIT: "ORGANIZATIONAL_STRUCTURE.EDIT",
        CREATE: "ORGANIZATIONAL_STRUCTURE.CREATE",
        DELETE: "ORGANIZATIONAL_STRUCTURE.DELETE",
        IMPORT: "ORGANIZATIONAL_STRUCTURE.IMPORT",
        EXPORT: "ORGANIZATIONAL_STRUCTURE.EXPORT",
        VIEW: "ORGANIZATIONAL_STRUCTURE.VIEW",
    },
    TEMPLATES: {
        EDIT: "TEMPLATES.EDIT",
        CREATE: "TEMPLATES.CREATE",
        DELETE: "TEMPLATES.DELETE",
        IMPORT: "TEMPLATES.IMPORT",
        EXPORT: "TEMPLATES.EXPORT",
        VIEW: "TEMPLATES.VIEW",
    },
    CAMPAIGNS: {
        EDIT: "CAMPAIGNS.EDIT",
        CREATE: "CAMPAIGNS.CREATE",
        DELETE: "CAMPAIGNS.DELETE",
        IMPORT: "CAMPAIGNS.IMPORT",
        EXPORT: "CAMPAIGNS.EXPORT",
        VIEW: "CAMPAIGNS.VIEW",
    },
    SURVEYS: {
        EDIT: "SURVEYS.EDIT",
        CREATE: "SURVEYS.CREATE",
        DELETE: "SURVEYS.DELETE",
        IMPORT: "SURVEYS.IMPORT",
        EXPORT: "SURVEYS.EXPORT",
        VIEW: "SURVEYS.VIEW",
    },
    PARTICIPANTS: {
        EDIT: "PARTICIPANTS.EDIT",
        CREATE: "PARTICIPANTS.CREATE",
        DELETE: "PARTICIPANTS.DELETE",
        IMPORT: "PARTICIPANTS.IMPORT",
        EXPORT: "PARTICIPANTS.EXPORT",
        VIEW: "PARTICIPANTS.VIEW",
    },
    GENERAL_PARAMETERS: {
        EDIT: "GENERAL_PARAMETERS.EDIT",
        CREATE: "GENERAL_PARAMETERS.CREATE",
        DELETE: "GENERAL_PARAMETERS.DELETE",
        IMPORT: "GENERAL_PARAMETERS.IMPORT",
        EXPORT: "GENERAL_PARAMETERS.EXPORT",
        VIEW: "GENERAL_PARAMETERS.VIEW",
    },
    SENTIMENT_PARAMETERS: {
        EDIT: "SENTIMENT_PARAMETERS.EDIT",
        CREATE: "SENTIMENT_PARAMETERS.CREATE",
        DELETE: "SENTIMENT_PARAMETERS.DELETE",
        IMPORT: "SENTIMENT_PARAMETERS.IMPORT",
        EXPORT: "SENTIMENT_PARAMETERS.EXPORT",
        VIEW: "SENTIMENT_PARAMETERS.VIEW",
    },
    ALERT_PARAMETERS: {
        EDIT: "ALERT_PARAMETERS.EDIT",
        CREATE: "ALERT_PARAMETERS.CREATE",
        DELETE: "ALERT_PARAMETERS.DELETE",
        IMPORT: "ALERT_PARAMETERS.IMPORT",
        EXPORT: "ALERT_PARAMETERS.EXPORT",
        VIEW: "ALERT_PARAMETERS.VIEW",
    },
    EVENTS: {
        EDIT: "EVENTS.EDIT",
        CREATE: "EVENTS.CREATE",
        DELETE: "EVENTS.DELETE",
        IMPORT: "EVENTS.IMPORT",
        EXPORT: "EVENTS.EXPORT",
        VIEW: "EVENTS.VIEW",
    },
    COMPLAINT_REOPEN_REASON: {
        EDIT: "COMPLAINT_REOPEN_REASON.EDIT",
        CREATE: "COMPLAINT_REOPEN_REASON.CREATE",
        DELETE: "COMPLAINT_REOPEN_REASON.DELETE",
        IMPORT: "COMPLAINT_REOPEN_REASON.IMPORT",
        EXPORT: "COMPLAINT_REOPEN_REASON.EXPORT",
        VIEW: "COMPLAINT_REOPEN_REASON.VIEW",
    },
    COMPLAINT_CLOSE_REASON: {
        EDIT: "COMPLAINT_CLOSE_REASON.EDIT",
        CREATE: "COMPLAINT_CLOSE_REASON.CREATE",
        DELETE: "COMPLAINT_CLOSE_REASON.DELETE",
        IMPORT: "COMPLAINT_CLOSE_REASON.IMPORT",
        EXPORT: "COMPLAINT_CLOSE_REASON.EXPORT",
        VIEW: "COMPLAINT_CLOSE_REASON.VIEW",
    },
    DEMAND_CANCEL_REASON: {
        EDIT: "DEMAND_CANCEL_REASON.EDIT",
        CREATE: "DEMAND_CANCEL_REASON.CREATE",
        DELETE: "DEMAND_CANCEL_REASON.DELETE",
        IMPORT: "DEMAND_CANCEL_REASON.IMPORT",
        EXPORT: "DEMAND_CANCEL_REASON.EXPORT",
        VIEW: "DEMAND_CANCEL_REASON.VIEW",
    },
    FUNCTIONAL_AREAS: {
        EDIT: "FUNCTIONAL_AREAS.EDIT",
        CREATE: "FUNCTIONAL_AREAS.CREATE",
        DELETE: "FUNCTIONAL_AREAS.DELETE",
        IMPORT: "FUNCTIONAL_AREAS.IMPORT",
        EXPORT: "FUNCTIONAL_AREAS.EXPORT",
        VIEW: "FUNCTIONAL_AREAS.VIEW",
    },
    SERVICES: {
        EDIT: "SERVICES.EDIT",
        CREATE: "SERVICES.CREATE",
        DELETE: "SERVICES.DELETE",
        IMPORT: "SERVICES.IMPORT",
        EXPORT: "SERVICES.EXPORT",
        VIEW: "SERVICES.VIEW",
    },
    CLAIM_PERSONAL_RELATIONSHIP: {
        EDIT: "CLAIM_PERSONAL_RELATIONSHIP.EDIT",
        CREATE: "CLAIM_PERSONAL_RELATIONSHIP.CREATE",
        DELETE: "CLAIM_PERSONAL_RELATIONSHIP.DELETE",
        IMPORT: "CLAIM_PERSONAL_RELATIONSHIP.IMPORT",
        EXPORT: "CLAIM_PERSONAL_RELATIONSHIP.EXPORT",
        VIEW: "CLAIM_PERSONAL_RELATIONSHIP.VIEW",
    },
    CLAIMS: {
        EDIT: "CLAIMS.EDIT",
        CREATE: "CLAIMS.CREATE",
        DELETE: "CLAIMS.DELETE",
        IMPORT: "CLAIMS.IMPORT",
        EXPORT: "CLAIMS.EXPORT",
        VIEW: "CLAIMS.VIEW",
        PRINT: "CLAIMS.PRINT",
        SHARE: "CLAIMS.SHARE",
        SEND_EMAIL: "CLAIMS.SEND_EMAIL"
    },
    AUDIT: {
        EDIT: "AUDIT.EDIT",
        CREATE: "AUDIT.CREATE",
        DELETE: "AUDIT.DELETE",
        IMPORT: "AUDIT.IMPORT",
        EXPORT: "AUDIT.EXPORT",
        VIEW: "AUDIT.VIEW",
    },
    GLOBAL_DASHBOARD: {
        EDIT: "GLOBAL_DASHBOARD.EDIT",
        CREATE: "GLOBAL_DASHBOARD.CREATE",
        DELETE: "GLOBAL_DASHBOARD.DELETE",
        IMPORT: "GLOBAL_DASHBOARD.IMPORT",
        EXPORT: "GLOBAL_DASHBOARD.EXPORT",
        VIEW: "GLOBAL_DASHBOARD.VIEW",
        PRINT: "GLOBAL_DASHBOARD.PRINT",
        SHARE: "GLOBAL_DASHBOARD.SHARE",
    },
    SURVEYS_PATIENTS: {
        EDIT: "SURVEYS_PATIENTS.EDIT",
        CREATE: "SURVEYS_PATIENTS.CREATE",
        DELETE: "SURVEYS_PATIENTS.DELETE",
        IMPORT: "SURVEYS_PATIENTS.IMPORT",
        EXPORT: "SURVEYS_PATIENTS.EXPORT",
        VIEW: "SURVEYS_PATIENTS.VIEW",
    },
    SURVEY_UPLOAD: {
        EDIT: "SURVEY_UPLOAD.EDIT",
        CREATE: "SURVEY_UPLOAD.CREATE",
        DELETE: "SURVEY_UPLOAD.DELETE",
        IMPORT: "SURVEY_UPLOAD.IMPORT",
        EXPORT: "SURVEY_UPLOAD.EXPORT",
        VIEW: "SURVEY_UPLOAD.VIEW",
    },
    SOCIAL_NETWORKS: {
        EDIT: "SOCIAL_NETWORKS.EDIT",
        CREATE: "SOCIAL_NETWORKS.CREATE",
        DELETE: "SOCIAL_NETWORKS.DELETE",
        IMPORT: "SOCIAL_NETWORKS.IMPORT",
        EXPORT: "SOCIAL_NETWORKS.EXPORT",
        VIEW: "SOCIAL_NETWORKS.VIEW",
    },
    SURVEYS_PROFESSIONALS: {
        EDIT: "SURVEYS_PROFESSIONALS.EDIT",
        CREATE: "SURVEYS_PROFESSIONALS.CREATE",
        DELETE: "SURVEYS_PROFESSIONALS.DELETE",
        IMPORT: "SURVEYS_PROFESSIONALS.IMPORT",
        EXPORT: "SURVEYS_PROFESSIONALS.EXPORT",
        VIEW: "SURVEYS_PROFESSIONALS.VIEW",
    },
    ALERTS: {
        EDIT: "ALERTS.EDIT",
        CREATE: "ALERTS.CREATE",
        DELETE: "ALERTS.DELETE",
        IMPORT: "ALERTS.IMPORT",
        EXPORT: "ALERTS.EXPORT",
        VIEW: "ALERTS.VIEW"
    },
    IMPROVEMENT_PLANS: {
        EDIT: "IMPROVEMENT_PLANS.EDIT",
        CREATE: "IMPROVEMENT_PLANS.CREATE",
        DELETE: "IMPROVEMENT_PLANS.DELETE",
        IMPORT: "IMPROVEMENT_PLANS.IMPORT",
        EXPORT: "IMPROVEMENT_PLANS.EXPORT",
        VIEW: "IMPROVEMENT_PLANS.VIEW",
    },
    FOLLOWUP_DEMAND: {
        EDIT: "FOLLOWUP_DEMAND.EDIT",
        CREATE: "FOLLOWUP_DEMAND.CREATE",
        DELETE: "FOLLOWUP_DEMAND.DELETE",
        IMPORT: "FOLLOWUP_DEMAND.IMPORT",
        EXPORT: "FOLLOWUP_DEMAND.EXPORT",
        VIEW: "FOLLOWUP_DEMAND.VIEW",
    },
    ALERT_CONFIG: {
        EDIT: "ALERT_CONFIG.EDIT",
        CREATE: "ALERT_CONFIG.CREATE",
        DELETE: "ALERT_CONFIG.DELETE",
        IMPORT: "ALERT_CONFIG.IMPORT",
        EXPORT: "ALERT_CONFIG.EXPORT",
        VIEW: "ALERT_CONFIG.VIEW",
    },
    TOPIC_MANAGEMENT: {
        EDIT: "TOPIC_MANAGEMENT.EDIT",
        CREATE: "TOPIC_MANAGEMENT.CREATE",
        DELETE: "TOPIC_MANAGEMENT.DELETE",
        IMPORT: "TOPIC_MANAGEMENT.IMPORT",
        EXPORT: "TOPIC_MANAGEMENT.EXPORT",
        VIEW: "TOPIC_MANAGEMENT.VIEW",
    },
    DEMAND_IN_FORMAT: {
        EDIT: "DEMAND_IN_FORMAT.EDIT",
        CREATE: "DEMAND_IN_FORMAT.CREATE",
        DELETE: "DEMAND_IN_FORMAT.DELETE",
        IMPORT: "DEMAND_IN_FORMAT.IMPORT",
        EXPORT: "DEMAND_IN_FORMAT.EXPORT",
        VIEW: "DEMAND_IN_FORMAT.VIEW",
    },
    DEMAND_OUT_FORMAT: {
        EDIT: "DEMAND_OUT_FORMAT.EDIT",
        CREATE: "DEMAND_OUT_FORMAT.CREATE",
        DELETE: "DEMAND_OUT_FORMAT.DELETE",
        IMPORT: "DEMAND_OUT_FORMAT.IMPORT",
        EXPORT: "DEMAND_OUT_FORMAT.EXPORT",
        VIEW: "DEMAND_OUT_FORMAT.VIEW",
    },
    DEMAND_DERIVATION: {
        EDIT: "DEMAND_DERIVATION.EDIT",
        CREATE: "DEMAND_DERIVATION.CREATE",
        DELETE: "DEMAND_DERIVATION.DELETE",
        IMPORT: "DEMAND_DERIVATION.IMPORT",
        EXPORT: "DEMAND_DERIVATION.EXPORT",
        VIEW: "DEMAND_DERIVATION.VIEW",
    },
    SECURITY_IP: {
        EDIT: "SECURITY_IP.EDIT",
        CREATE: "SECURITY_IP.CREATE",
        DELETE: "SECURITY_IP.DELETE",
        IMPORT: "SECURITY_IP.IMPORT",
        EXPORT: "SECURITY_IP.EXPORT",
        VIEW: "SECURITY_IP.VIEW",
    },
    EXTRA_FIELDS: {
        EDIT: "EXTRA_FIELDS.EDIT",
        CREATE: "EXTRA_FIELDS.CREATE",
        DELETE: "EXTRA_FIELDS.DELETE",
        IMPORT: "EXTRA_FIELDS.IMPORT",
        EXPORT: "EXTRA_FIELDS.EXPORT",
        VIEW: "EXTRA_FIELDS.VIEW",
    },
    NOTIFICATIONS: {
        EDIT: "NOTIFICATIONS.EDIT",
        CREATE: "NOTIFICATIONS.CREATE",
        DELETE: "NOTIFICATIONS.DELETE",
        IMPORT: "NOTIFICATIONS.IMPORT",
        EXPORT: "NOTIFICATIONS.EXPORT",
        VIEW: "NOTIFICATIONS.VIEW",
    },
    CLAIM_REQUEST_TYPE: {
        EDIT: "CLAIM_REQUEST_TYPE.EDIT",
        CREATE: "CLAIM_REQUEST_TYPE.CREATE",
        DELETE: "CLAIM_REQUEST_TYPE.DELETE",
        IMPORT: "CLAIM_REQUEST_TYPE.IMPORT",
        EXPORT: "CLAIM_REQUEST_TYPE.EXPORT",
        VIEW: "CLAIM_REQUEST_TYPE.VIEW",
    },
    USER_COMMUNICATION_TYPE: {
        EDIT: "USER_COMMUNICATION_TYPE.EDIT",
        CREATE: "USER_COMMUNICATION_TYPE.CREATE",
        DELETE: "USER_COMMUNICATION_TYPE.DELETE",
        IMPORT: "USER_COMMUNICATION_TYPE.IMPORT",
        EXPORT: "USER_COMMUNICATION_TYPE.EXPORT",
        VIEW: "USER_COMMUNICATION_TYPE.VIEW",
    },
    CAMPAIGN_CLOSED_REASON: {
        EDIT: "CAMPAIGN_CLOSED_REASON.EDIT",
        CREATE: "CAMPAIGN_CLOSED_REASON.CREATE",
        DELETE: "CAMPAIGN_CLOSED_REASON.DELETE",
        IMPORT: "CAMPAIGN_CLOSED_REASON.IMPORT",
        EXPORT: "CAMPAIGN_CLOSED_REASON.EXPORT",
        VIEW: "CAMPAIGN_CLOSED_REASON.VIEW",
    },
    PROFESSIONAL_MANAGEMENT: {
        EDIT: "PROFESSIONAL_MANAGEMENT.EDIT",
        CREATE: "PROFESSIONAL_MANAGEMENT.CREATE",
        DELETE: "PROFESSIONAL_MANAGEMENT.DELETE",
        IMPORT: "PROFESSIONAL_MANAGEMENT.IMPORT",
        EXPORT: "PROFESSIONAL_MANAGEMENT.EXPORT",
        VIEW: "PROFESSIONAL_MANAGEMENT.VIEW",
    },
    REPORT_DEFINITIONS: {
        EDIT: "REPORT_DEFINITIONS.EDIT",
        CREATE: "REPORT_DEFINITIONS.CREATE",
        DELETE: "REPORT_DEFINITIONS.DELETE",
        IMPORT: "REPORT_DEFINITIONS.IMPORT",
        EXPORT: "REPORT_DEFINITIONS.EXPORT",
        VIEW: "REPORT_DEFINITIONS.VIEW",
    },
    IMPROVEMENT_PLAN_DELETE_REASON: {
        EDIT: "IMPROVEMENT_PLAN_DELETE_REASON.EDIT",
        CREATE: "IMPROVEMENT_PLAN_DELETE_REASON.CREATE",
        DELETE: "IMPROVEMENT_PLAN_DELETE_REASON.DELETE",
        IMPORT: "IMPROVEMENT_PLAN_DELETE_REASON.IMPORT",
        EXPORT: "IMPROVEMENT_PLAN_DELETE_REASON.EXPORT",
        VIEW: "IMPROVEMENT_PLAN_DELETE_REASON.VIEW",
    },
    IMPROVEMENT_PLAN_FINALIZE_REASON: {
        EDIT: "IMPROVEMENT_PLAN_FINALIZE_REASON.EDIT",
        CREATE: "IMPROVEMENT_PLAN_FINALIZE_REASON.CREATE",
        DELETE: "IMPROVEMENT_PLAN_FINALIZE_REASON.DELETE",
        IMPORT: "IMPROVEMENT_PLAN_FINALIZE_REASON.IMPORT",
        EXPORT: "IMPROVEMENT_PLAN_FINALIZE_REASON.EXPORT",
        VIEW: "IMPROVEMENT_PLAN_FINALIZE_REASON.VIEW",
    },
    IMPROVEMENT_PLAN_ORIGIN: {
        EDIT: "IMPROVEMENT_PLAN_ORIGIN.EDIT",
        CREATE: "IMPROVEMENT_PLAN_ORIGIN.CREATE",
        DELETE: "IMPROVEMENT_PLAN_ORIGIN.DELETE",
        IMPORT: "IMPROVEMENT_PLAN_ORIGIN.IMPORT",
        EXPORT: "IMPROVEMENT_PLAN_ORIGIN.EXPORT",
        VIEW: "IMPROVEMENT_PLAN_ORIGIN.VIEW",
    },
    IMPROVEMENT_PLAN_TYPE: {
        EDIT: "IMPROVEMENT_PLAN_TYPE.EDIT",
        CREATE: "IMPROVEMENT_PLAN_TYPE.CREATE",
        DELETE: "IMPROVEMENT_PLAN_TYPE.DELETE",
        IMPORT: "IMPROVEMENT_PLAN_TYPE.IMPORT",
        EXPORT: "IMPROVEMENT_PLAN_TYPE.EXPORT",
        VIEW: "IMPROVEMENT_PLAN_TYPE.VIEW",
    },

    
} as const;     

export type PermissionType = typeof PERMISSIONS;


export const PERMISSION_MODULES = {
    ADMINISTRATION: {
        ca: "Configuració administrativa",
        es: "Configuración administrativa",
        en: "Administrative settings",
    },
    CLIENT_MANAGEMENT: {
        ca: "Clients",
        es: "Clientes",
        en: "Clients",
    },
    USERS_CLIENT: {
        ca: "Usuaris del client",
        es: "Usuarios del cliente",
        en: "Client users",
    },
    ROLES: {
        ca: "Rols i permisos",
        es: "Roles y permisos",
        en: "Roles and permissions",
    },
    ORGANIZATIONAL_STRUCTURE: {
        ca: "Estructura organitzativa",
        es: "Estructura organizativa",
        en: "Organizational structure",
    },
    SURVEY_UPLOAD: {
        ca: "Càrrega d'enquestes",
        es: "Carga de encuestas",
        en: "Survey uploads",
    },
    TEMPLATES: {
        ca: "Plantilles",
        es: "Plantillas",
        en: "Templates",
    },
    CAMPAIGNS: {
        ca: "Campanyes",
        es: "Campañas",
        en: "Campaigns",
    },
    SURVEYS: {
        ca: "Enquestes",
        es: "Encuestas",
        en: "Surveys",
    },
    PARTICIPANTS: {
        ca: "Participants",
        es: "Participantes",
        en: "Participants",
    },
    GENERAL_PARAMETERS: {
        ca: "Paràmetres generals",
        es: "Parámetros generales",
        en: "General parameters",
    },
    SENTIMENT_PARAMETERS: {
        ca: "Paràmetres de sentiment",
        es: "Parámetros de sentimiento",
        en: "Sentiment parameters",
    },
    ALERT_PARAMETERS: {
        ca: "Paràmetres d'alertes",
        es: "Parámetros de alertas",
        en: "Alert parameters",
    },
    EVENTS: {
        ca: "Esdeveniments",
        es: "Eventos",
        en: "Events",
    },
    COMPLAINT_REOPEN_REASON: {
        ca: "Motius de reobertura",
        es: "Motivos de reapertura",
        en: "Reopen reasons",
    },
    COMPLAINT_CLOSE_REASON: {
        ca: "Motius de tancament",
        es: "Motivos de cierre",
        en: "Close reasons",
    },
    FUNCTIONAL_AREAS: {
        ca: "Àrees funcionals",
        es: "Áreas funcionales",
        en: "Functional areas",
    },
    SERVICES: {
        ca: "Serveis",
        es: "Servicios",
        en: "Services",
    },
    CLAIMS: {
        ca: "Reclamacions",
        es: "Reclamaciones",
        en: "Claims",
    },
    AUDIT: {
        ca: "Auditoria",
        es: "Auditoría",
        en: "Audit log",
    },
    GLOBAL_DASHBOARD: {
        ca: "Panell global",
        es: "Panel global",
        en: "Global dashboard",
    },
    SURVEYS_PATIENTS: {
        ca: "Enquestes a pacients",
        es: "Encuestas a pacientes",
        en: "Surveys for patients",
    },
    SOCIAL_NETWORKS: {
        ca: "Xarxes socials",
        es: "Redes sociales",
        en: "Social networks",
    },
    SURVEYS_PROFESSIONALS: {
        ca: "Enquestes a professionals",
        es: "Encuestas a profesionales",
        en: "Surveys for professionals",
    },
    ALERTS: {
        ca: "Alertes",
        es: "Alertas",
        en: "Alerts",
    },
    ALERT_CONFIG: {
        ca: "Valors d'alertes",
        es: "Valores de alertas",
        en: "Alert values",
    },
    DEMAND_IN_FORMAT: {
        ca: "Demanda Format d'entrada",
        es: "Demanda Formato de entrada",
        en: "Request input format",
    },
    DEMAND_OUT_FORMAT: {
        ca: "Demanda Format de sortida",
        es: "Demanda Formato de salida",
        en: "Request output format",
    },
    DEMAND_DERIVATION: {
        ca: "Derivacions a punts de gestió",
        es: "Derivaciones a puntos de gestión",
        en: "Derivations to management points",
    },
    EXTRA_FIELDS: {
        ca: "Gestió de camps extra",
        es: "Extra fields management",
        en: "Gestión de Campos extra",
    },
    NOTIFICATIONS: {
        ca: "Gestió de notificacions",
        es: "Notifications",
        en: "Gestión de notificaciones",
    },
    CLAIM_REQUEST_TYPE: {
        ca: "Tipus de demanda",
        es: "Request type",
        en: "Tipo de demanda",
    },
    USER_COMMUNICATION_TYPE: {
        ca: "Tipus de comunicació amb l'usuari",
        es: "Tipo de comunicación con el usuario",
        en: "User communtication type",
    },
    CAMPAIGN_CLOSED_REASON: {
        ca: "Motiu tancament campanya",
        es: "Motivo de cierre de campaña",
        en: "New campaign closure reason",
    },
    PROFESSIONAL_MANAGEMENT: {
        ca: "Gestió de professionals",
        es: "Gestion de profesionales",
        en: "Professional management",
    },
    REPORT_DEFINITIONS: {
        ca: "Informes",
        es: "Informes",
        en: "Reports",
    },
    IMPROVEMENT_PLAN_DELETE_REASON: {
        ca: "Plans de millora Motius Anulació",
        es: "Plan de mejoras Motivos de eliminación",
        en: "Improvement plan delete reasons",
    },
    IMPROVEMENT_PLAN_FINALIZE_REASON: {
        ca: "Plans de millora Motius de finalització",
        es: "Plan de mejoras Motivos de finalización",
        en: "Improvement plan closure reasons",
    },
    IMPROVEMENT_PLAN_ORIGIN: {
        ca: "Plans de millora Procedència",
        es: "Plan de mejoras Orígenes",
        en: "Improvement plan origins",
    },
    IMPROVEMENT_PLAN_TYPE: {
        ca: "Plans de millora Tipus",
        es: "Plan de mejoras Tipos",
        en: "Improvement plan Types",
    },

    
} as const;

export const PERMISSION_ACTIONS = {
    EDIT: {
        ca: "Modificar informació existent",
        es: "Modificar información existente",
        en: "Modify existing information",
    },
    CREATE: {
        ca: "Crear nous elements",
        es: "Crear nuevos elementos",
        en: "Create new items",
    },
    DELETE: {
        ca: "Eliminar elements",
        es: "Eliminar elementos",
        en: "Delete items",
    },
    IMPORT: {
        ca: "Importar dades des d'arxius",
        es: "Importar datos desde archivos",
        en: "Import data from files",
    },
    EXPORT: {
        ca: "Exportar dades a arxius",
        es: "Exportar datos a archivos",
        en: "Export data to files",
    },
    VIEW: {
        ca: "Veure informació",
        es: "Ver información",
        en: "View information",
    },
} as const;